import { get } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ActivatedRoute } from '@angular/router';

import { deepSearchRouteDataItem } from '../helpers';

export function mapToRouteDataItem<D = any>(
  key: string,
  deep: boolean = false,
): (source: Observable<ActivatedRoute>) => Observable<D> {
  return (source: Observable<ActivatedRoute>) => {
    return source.pipe(
      map((route) => {
        return deep ? deepSearchRouteDataItem(route, key) : get(route.snapshot.data, key);
      }),
    );
  };
}
